module.exports = __webpack_public_path__ + "static/media/concelho.1644ea3f.png";